import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import styles from "../custom.module.css";

import userCard from "../../assets/img/user/card/green/01.png";
import userCard2 from "../../assets/img/user/card/green/02.png";
import userCard3 from "../../assets/img/user/card/green/03.png";
import userCard4 from "../../assets/img/user/card/green/04.png";
import DirectTeamReport from "./teamDataTables/DirectTeamReport";
import TeamReport from "./teamDataTables/TeamReport";

import { getWalletData } from "../../redux/actions/wallet";
import { getteamData } from "../../redux/actions/team";

const TeamData = () => {
  const dispatch = useDispatch();
  
  // Select data from Redux store using useSelector
  const walletData = useSelector((state) => state.wallet.walletData);
  const teamData = useSelector((state) => state.team.teamData);

  const [isDirectReport, setDirectReport] = useState(true);

  useEffect(() => {
    console.log("🔄 TeamData - Fetching wallet and team data");
    dispatch(getWalletData());
    dispatch(getteamData());
  }, [dispatch]);

  // Calculate total investment
  const totalInvestment = React.useMemo(() => {
    if (walletData?.GrowthData?.updatedPackagesData) {
      const packagesData = walletData.GrowthData.updatedPackagesData;
      return packagesData.reduce((total, element) => {
        return total + (element.Package?.pkg_amount || 0);
      }, 0);
    }
    return 0;
  }, [walletData?.GrowthData?.updatedPackagesData]);

  // console.log("📊 TeamData - Component Data:", {
  //   totalInvestment,
  //   walletData: !!walletData,
  //   teamData: !!teamData,
  //   isDirectReport
  // });

  return (
    <div>
      <section className="user-ditails-wrapper fix section-bg-5 section-padding-medium">
        <div className="container ">
          <div className="row section-padding-medium">
            {/* Total Investment & Earnings Card */}
            <div className="col-xl-3 col-sm-6">
              <div
                className="single-user-ditails-card single-user-ditails-card--style2 mb-4 mb-xl-0 wow fadeInUp"
                data-wow-duration="1s"
                data-wow-delay=".2s"
              >
                <div className="user-card-wrapper ">
                  <div className="user-card-thumb">
                    <img src={userCard} alt="invest icon" />
                  </div>
                  <div className="user-card-content mt-2">
                    <div className={styles.twoColumns}>
                      <div className="col">
                        <div className={styles.fontMediumBold}>
                          Total Investment
                        </div>
                        <p>${totalInvestment.toFixed(2)}</p>
                      </div>
                      <div className="col">
                        <div className={styles.fontMediumBold}>
                          Total Earning
                        </div>
                        <p>
                          $
                          {(walletData?.GrowthData?.totalGrowth || 0.0).toFixed(2)}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Direct Members & Business Card */}
            <div className="col-xl-3 col-sm-6">
              <div
                className="single-user-ditails-card single-user-ditails-card--style2 mb-4 mb-xl-0 wow fadeInUp"
                data-wow-duration="1s"
                data-wow-delay=".2s"
              >
                <div className="user-card-wrapper">
                  <div className="user-card-thumb">
                    <img src={userCard2} alt="invest icon" />
                  </div>
                  <div className="user-card-content mt-2">
                    <div className={styles.twoColumns}>
                      <div className="col">
                        <div className={styles.fontMediumBold}>
                          Direct Members
                        </div>
                        <p>{teamData?.directTeamCount || 0}</p>
                      </div>
                      <div className="col">
                        <div className={styles.fontMediumBold}>
                          Direct Business
                        </div>
                        <p>${(teamData?.directBusiness || 0.0).toFixed(2)}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Team Members & Business Card */}
            <div className="col-xl-3 col-sm-6">
              <div
                className="single-user-ditails-card single-user-ditails-card--style2 mb-4 mb-xl-0 wow fadeInUp"
                data-wow-duration="1s"
                data-wow-delay=".2s"
              >
                <div className="user-card-wrapper">
                  <div className="user-card-thumb">
                    <img src={userCard3} alt="invest icon" />
                  </div>
                  <div className="user-card-content mt-2">
                    <div className={styles.twoColumns}>
                      <div className="col">
                        <div className={styles.fontMediumBold}>
                          Team Members
                        </div>
                        <p>{teamData?.totalTeamCount || 0}</p>
                      </div>
                      <div className="col">
                        <div className={styles.fontMediumBold}>
                          Team Business
                        </div>
                        <p>${(teamData?.grandTotalBusiness || 0.0).toFixed(2)}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Today's Business & Joining Card */}
            <div className="col-xl-3 col-sm-6">
              <div
                className="single-user-ditails-card single-user-ditails-card--style2 mb-4 mb-xl-0 wow fadeInUp"
                data-wow-duration="1s"
                data-wow-delay=".2s"
              >
                <div className="user-card-wrapper">
                  <div className="user-card-thumb">
                    <img src={userCard4} alt="invest icon" />
                  </div>
                  <div className="user-card-content mt-2">
                    <div className={styles.twoColumns}>
                      <div className="col">
                        <div className={styles.fontMediumBold}>
                          Today's Business
                        </div>
                        <p>${(teamData?.todaysCount?.todaysBusiness || 0.0).toFixed(2)}</p>
                      </div>
                      <div className="col">
                        <div className={styles.fontMediumBold}>
                          Today's Joining
                        </div>
                        <p>{teamData?.todaysCount?.todaysJoiningCount || 0}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Report Toggle Section */}
        <div
          className="container wow fadeInUp"
          data-wow-duration="1s"
          data-wow-delay=".2s"
        >
          <div className={styles.twoColumns}>
            <div className="text-center">
              <button
                className={`btn ${isDirectReport ? 'btn-primary' : 'btn-outline-primary'}`}
                onClick={() => setDirectReport(true)}
              >
                Direct Team Report
              </button>
            </div>
            <div className="text-center">
              <button
                className={`btn ${!isDirectReport ? 'btn-danger' : 'btn-outline-danger'}`}
                onClick={() => setDirectReport(false)}
              >
                Generation Team Report
              </button>
            </div>
          </div>

          {/* Conditional Rendering of Reports */}
          {isDirectReport ? (
            <DirectTeamReport teamData={teamData} />
          ) : (
            <TeamReport teamData={teamData} />
          )}
        </div>
      </section>
    </div>
  );
};

export default TeamData;